import jsapi from './index.js';
import { elk } from "../report";
import { to } from '../util';
const reportApiList = ['getH5TransactionRequest', 'getSupportSoter', 'requireSoterBiometricAuthentication', 'handleWCPayWalletBuffer'];
/**
 * 创建上报版本的jsapi
 * TODO: 这里会打包全部到jsapi么，不会触发tree shaking
 * 会将jsapi调用的入参和返回上报到elk
 * @return {[type]} [description]
 */
function _createJsapiReportVer() {
  let proxy = {};
  Object.keys(jsapi).forEach(key => {
    proxy[key] = async (...args) => {
      const params = args;
      const isReport = reportApiList.indexOf(key) > -1;
      const startTime = new Date().getTime();

      isReport ? elk({
        key: `proxy_jsapi_before_call_${key}`,
        body: params
      }) : '';

      const [err, res] = await to(jsapi[key].call(null, ...args));
      const cost = new Date().getTime() - startTime;
      
      isReport ? elk({
        key: `proxy_jsapi_${key}`,
        time_diff: cost,
        body: params,
        msg: {
          data: err ? err.message : res,
          jestInfo: {
            isReject: err ? true : false,
            async: true
          }
        }
      }) : '';

      if (err) {
        throw err;
      }
      return res;
    };
  });
  return proxy;
}

const jsapiProxy = _createJsapiReportVer();

export default jsapiProxy;
